import { render, staticRenderFns } from "./MPopupUploadImgUnsplash.vue?vue&type=template&id=d2260b7c&"
import script from "./MPopupUploadImgUnsplash.vue?vue&type=script&lang=ts&"
export * from "./MPopupUploadImgUnsplash.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports